import React, { Component } from "react";
import { AES, enc } from 'crypto-js';
import { GetBookingConfirm } from "../../Services/FlightDetails"
//import { GetBookingConfirmIR } from "../../Services/FlightDetails"
import { useLocation} from "react-router-dom";
import { GetTicketCopyUrl } from "../../Services/FlightDetails"
import {URL_EncodeKey} from "../../Services/EncryptionService"
import { GetFooterDetails } from "../../Services/UtilitiesServices";
import { withTranslation } from 'react-i18next';
import { useNavigate, json } from 'react-router-dom'
class BookingSuccess extends Component {

  constructor(props) {
    super(props);
    this.state = {
      contactNo: "",
      email: "",
      country: localStorage.getItem("selectedCountryCode"),
      isLoaded: false,
      BookingSegmentDetails: [],
      BookingPaxlistRsp: [],
      BookingResponse: [],
      // objseglistResult: [],
      // TaxListResult: [],
      // AdtpricingPaxListResult: [],
      // ChdpricingPaxListResult: [],
      // InfpricingPaxListResult: [],
      // //objbaggageListResult: [],
      // itinId: 0,
      // fareId: 0,
      // providerCode: "",
      // requestBody: {},
      // RePricingDetailsResult: [],
      // ReobjseglistResult: [],
      // ReTaxListResult: [],

      // objAdtPaxList:[],
      // objchdPaxList:[],  
      // objinfPaxList:[],     

    };
  }
 changeLanguage = (lng) => {
    const { i18n } = this.props;
    i18n.changeLanguage(lng);
    document.body.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.body.style.textAlign = lng === 'ar' ? 'right' : 'left';
  };
  componentDidMount() {

    this.fetchFooter();

    
    this.interval = setInterval(() => {
      const currentCountry = localStorage.getItem("selectedCountryCode");

      if (currentCountry !== this.state.country) {
        this.setState({ country: currentCountry }, () => {
          this.fetchFooter();
        });
      }
    }, 500);

    // Access the passed data from props.location.state

    
    const { location } = this.props;
    //const { bookParam } = location.state;
    this.setState({
      isLoaded:false,
    });
    const params = new URLSearchParams(window.location.search);
    if(params.get('BookingConfirmRequest')!== null)
    {
    const BookingConfirmRequest = params.get('BookingConfirmRequest');
 
    // Same secret key used for encryption
    const secretKey = URL_EncodeKey();
    
    //Decrypt the encrypted data
    const decryptedData = AES.decrypt(BookingConfirmRequest, secretKey).toString(enc.Utf8);
    
    //Parse the decrypted data back to an object
    const parsedData = JSON.parse(decryptedData);


    this.setState({
            BookingSegmentDetails: parsedData.objSegmentList,
            BookingPaxlistRsp: parsedData.objPaxlist,
            
            BookingResponse: parsedData,
            isLoaded: true,
          });
   
   
      //this.requestBody = JSON.parse(localStorage.getItem("onewayBookingResult"));
      // this.requestBody = bookParam;
      // console.log(bookParam);
      //let response = parsedData;
     
    //        GetBookingConfirm(this.requestBody).then((response) => {
            
    //     // console.log(response);
       

    //   if (response.data.status) {
    //     this.setState({


    //       BookingSegmentDetails: response.data.objSegmentList,
    //       BookingPaxlistRsp: response.data.objPaxlist,
          
    //       BookingResponse: response.data,
    //       isLoaded: true,
    //     });

    //    }
    //  })
    // .catch((error) => {
    //   if(error.response.data.responseMessage=="InvalidToken")
    //   {
    //     // Swal.fire(
    //     //   'Unauthorized Access !',
    //     //   'Please Login Again',
    //     //   'warning'
    //     // )
        
    //     this.props.navigate('/');
        
    //   }
    // });
    }
  
  //   if(params.get('IRTBookingConfirmRequest')!== null)
  //   {
  //     const IRTBookingConfirmRequest = params.get('IRTBookingConfirmRequest');
  // // Same secret key used for encryption
  // const secretKey = '123';
  
  // // Decrypt the encrypted data
  // const IRTdecryptedData = AES.decrypt(IRTBookingConfirmRequest, secretKey).toString(enc.Utf8);
  
  // // Parse the decrypted data back to an object
  // const IRTparsedData = JSON.parse(IRTdecryptedData);
   
  //     //this.requestBody = JSON.parse(localStorage.getItem("onewayBookingResult"));
  //     //this.requestBody = JSON.parse(checkoutRequest);
  //     //this.requestBody1 = JSON.parse(localStorage.getItem("IRTBookingResult"));
  //     this.requestBody1 = IRTparsedData;
  //     // this.setState({
  //     //   requestBody:JSON.parse(localStorage.getItem("crtBookingResult"))
  //     // })
  //     GetBookingConfirmIR(this.requestBody1).then((response) => {
  //       if (response.data.status) {
  //         this.setState({
  
  
  //           BookingSegmentDetails: response.data.objSegmentList,
  //           BookingPaxlistRsp: response.data.objPaxlist,
            
  //           BookingResponse: response.data,
  //           //isLoaded: true,
  //         });
  //       }
  //     })
  //     .catch((error) => {

  //       if(error.response.data.responseMessage=="InvalidToken")
  //       {
  //         Swal.fire(
  //           'Unauthorized Access !',
  //           'Please Login Again',
  //           'warning'
  //         )
          
  //         this.props.navigate('/');
          
  //       }
  //     });
  //   }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

fetchFooter = async () => {
    try {
      console.log("Calling API for country:", this.state.country);
      const res = await GetFooterDetails();
      this.setState({ email: res.data.b2CEmail,contactNo: res.data.b2CContactNo });
    } catch (error) {
      console.error("Footer API error:", error);
    }
  };




  handleDownload = (url) => {
    // const data = {
    //   pnr: pnr,
    //   pnrType: 1,
    //   withFare: false,
    //   withTaxSplitup: false
    // };
 
   
    //GetTicketCopyUrl(data).then((response) => {    
      //if (response.data.status) { 


          const pdfFilePath = url;
          
          fetch(pdfFilePath)
            .then(response => response.blob())
            .then(blob => {
              // Create a URL object from the blob
              const url = URL.createObjectURL(blob);
              
              // Open a new window or tab to display the PDF
              window.open(url, '_blank');
            })
            .catch(error => {
              console.error('Error downloading PDF:', error);
            });
      //}
      //else
      //{
        
      //}
    //})
      // .catch((error) => {
      
      //   if (error.response.data.responseMessage == "InvalidToken") {
          

      //     this.props.navigate('/');

      //   }
      //   const url = "";
      //   // Open a new window or tab to display the PDF
      //   window.open(url, '_blank');
      // })
      // .catch(error => {
      //   // console.error('Error downloading PDF:', error);
      // });
    
  };


  render() { 
const { t } = this.props;
    const currencyMap = {
      IN: "₹",
      AE: "AED",
      SA: "SAR",
      QA: "QAR",
      OM: "OMR",
      BH: "BHD",
      KW: "KWD"
    };

    const currencySymbol = currencyMap[this.state.BookingResponse.defaultCountry] || "";

  return (this.state.isLoaded) ? (
    <div>
 <div className="passenger-details-area pt-5">
  <div className="container">
    <div className="row">
      <div className="col-lg-9 col-md-9">
        {this.state.BookingResponse.status == true && this.state.BookingResponse.statusReturn == true && (
         <div className="row">
          <div className="col-lg-1 col-md-1 col-12 success-icon">
            <img src="assets/img/success.png" width={70} className="oneway-desk" />
            <img src="assets/img/success.png" width={100} className="oneway-mob" style={{ margin: '0 auto' }} />
          </div>
          <div className="col-lg-8 col-md-8 col-12 b-confirm">
            <h3>Your Booking Confirmed!</h3>
              <p className="no-margin">Thank you for booking with Alhind!</p>
        <p className="no-margin">Your E-ticket has been sent to <strong>{this.state.BookingResponse.email}</strong>.<br /></p>
        
        {this.state.BookingResponse.bookingReferenceIdR!=null && 
        
          <table className="table" style={{ marginTop: '20px' }}>
        
             <strong>PNR / Booking ID:</strong>
           
            <tr>
              <td style={{ width: '120px', padding: '10px' }}>Onward:</td>
              <td style={{ padding: '10px' }}><strong>{this.state.BookingResponse.bookingReferenceId}</strong></td>
              <td style={{ padding: '10px' }}> <a className="btn btn-primary" style={{fontSize : '0.9em'}} href={this.state.BookingResponse.ticketUrl} target="_blank">
            <img src="assets/img/ticket.svg" width={30} /> Get your Ticket
          </a></td>
            </tr>
            <tr>
              <td style={{ width: '120px', padding: '10px' }}>Return:</td>
              <td style={{ padding: '10px' }}><strong>{this.state.BookingResponse.bookingReferenceIdR}</strong></td>
              <td style={{ padding: '10px' }}> <a className="btn btn-primary" style={{fontSize : '0.9em'}} href={this.state.BookingResponse.ticketUrlR} target="_blank">
            <img src="assets/img/ticket.svg" width={30} /> Get your Ticket
          </a></td>
            </tr>
          </table>
        }
        
        {this.state.BookingResponse.bookingReferenceIdR==null && <p className="no-margin">PNR / Booking ID: <strong>{this.state.BookingResponse.bookingReferenceId}</strong> </p>}
        
        <div className="mb-3"><h3 className="no-margin you-paid">You Paid <strong>{currencySymbol} {" "}
           {Math.round(this.state.BookingResponse.paidAmount)}</strong></h3></div>
          </div>
          {this.state.BookingResponse.bookingReferenceIdR==null && 
            <div className="col-lg-3 col-md-3 col-12 float-end text-right mb-3 ticket-download">
              <a className="btn btn-primary full-width" href={this.state.BookingResponse.ticketUrl} target="_blank">
                <img src="assets/img/ticket.svg" width={30} /> Get your Ticket
              </a>
            </div>
          }
       
      
         </div> 
        )}
{/* Failed Booking section starts */}
{this.state.BookingResponse.status == false && this.state.BookingResponse.statusReturn == false && (
<div className="row">
          <div className="col-lg-2 col-md-2 mb-3">
            <img src="assets/img/booking-failed.png" width={100} />
          </div>
          <div className="col-lg-9 col-md-9" style={{minHeight: '310px'}}>
            <h3>Your Booking Failed!</h3>
              <p className="no-margin">Please contact with our customer care</p>
       
        
        
          </div>
          
       
      
         </div>
)}

{(this.state.BookingResponse.status ^ this.state.BookingResponse.statusReturn) ? (
  <div className="row">
    <div className="col-lg-2 col-md-2 mb-3">
      <img src="assets/img/booking-failed.png" width={100} />
    </div>
    <div className="col-lg-9 col-md-9">
      <h3>Your Booking is Partially Failed!</h3>
      <p className="no-margin">Please contact our customer care</p>
    </div>

    {this.state.BookingResponse.bookingReferenceIdR == null && (
      <div className="row">
        <div className="col-lg-9 col-md-9">
          <p className="no-margin">
            PNR / Booking ID: <strong>{this.state.BookingResponse.bookingReferenceId}</strong>
          </p>
          <div className="mb-3">
            <h3 className="no-margin">You Paid <strong>{currencySymbol} {" "}
               {Math.round(this.state.BookingResponse.paidAmount)}</strong></h3>
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-12 float-end text-right mb-3 ticket-download">
          <a className="btn btn-primary full-width" href={this.state.BookingResponse.ticketUrl} target="_blank">
            <img src="assets/img/ticket.svg" width={30} /> Get your Ticket
          </a>
        </div>
      </div>
    )}

    {this.state.BookingResponse.bookingReferenceId == null && (
      <div className="row">
        <div className="col-lg-9 col-md-9">
          <p className="no-margin">
            PNR / Booking ID: <strong>{this.state.BookingResponse.bookingReferenceIdR}</strong>
          </p>
          <div className="mb-3">
            <h3 className="no-margin">You Paid <strong>{currencySymbol} {" "}
               {Math.round(this.state.BookingResponse.paidAmount)}</strong></h3>
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-12 float-end text-right mb-3 ticket-download">
          <a className="btn btn-primary full-width" href={this.state.BookingResponse.ticketUrlR} target="_blank">
            <img src="assets/img/ticket.svg" width={30} /> Get your Ticket
          </a>
        </div>
      </div>
    )}
  </div>
) : (<div></div>)}
{/* Failed Booking section ends */}

 {/*flight details desktop starts*/}
{this.state.BookingResponse.status == true && this.state.BookingResponse.statusReturn == true && (
<div className="flight-details oneway-desk">
        <h4 className="td-head">Flight Details</h4>
        {/*Flight details*/}  
        <div className="deal-wrapper mb-3">
        {this.state.BookingSegmentDetails.map((item, index) => (
          <div className="t-details-area mb-0" key={index}>
          <div className="row align-items-center">
            <div className="airline-company col-lg-2 col-md-2 text-center">
              <img src={`assets//img/logos/${item.airlineCode}.gif`} width={40} />
              <p className="small-text">{item.airlineName}<br />{item.airlineCode}</p>
            </div>
            <div className="route-details-area col-lg-2 col-md-2 text-right">
              <div className="row">
                <p className="small-text">{item.departureAirportCode}</p>
                <h6 className="time-text">{item.departureTime}</h6>
                <p className="small-text text-grey">{item.departureDate}<br />{item.departureCity}</p>
              </div>
            </div>
            <div className="travel-time col-lg-2 col-md-2 text-center">
              <p className="small-text text-grey">{item.travelDuration}</p>
              <span><img src="assets/img/arrow.png"  /></span>
              {/* <p className="small-text text-grey">{item.stop }</p> */}
            </div>
            <div className="route-details-area col-lg-2 col-md-2 text-left">
              <div className="row">
                <p className="small-text">{item.arrivalAirportCode}</p>
                <h6 className="time-text">{item.arrivalTime}</h6>
                <p className="small-text text-grey">{item.arrivalDate}<br />{item.arrivalCity}</p>
              </div>
            </div>
            <div className="col-lg-2 col-md-2 airline-price-area">
           
               <p className="small-text">{item.airlineFlightClass}</p>
               {item.cabinBaggage.length > 0 && (
                  <p className="small-text"><img src="assets/img/baggage.svg" width={15} /> {item.cabinBaggage}</p>
               )}
            </div>
            <div className="col-lg-2 col-md-2">
              <p className="no-margin"><strong>PNR: {item.airlinePnr}</strong></p>
            </div>
          </div>
        </div>
          ))}
        </div>
        </div>
)}
        {/*flight details desktop ends*/}

{/* flight details mobile starts */}

{this.state.BookingResponse.status == true && this.state.BookingResponse.statusReturn == true && (
<div className="flight-details oneway-mob confirm-mob">
        <h4 className="td-head">Flight Details</h4>
        {/*Flight details*/}  
        <div className="deal-wrapper mb-3">
        {this.state.BookingSegmentDetails.map((item, index) => (
          <div className="t-details-area mb-0" key={index}>
            <ul className="d-flex flex-row">
              <li><img src={`assets//img/logos/${item.airlineCode}.gif`} width={40} /></li>
              <li>{item.airlineName}</li>
              <li>{item.airlineCode}</li>
            </ul>
          <div className="row">
            
            <div className="route-details-area col-lg-4 col-md-4 col-4">
              <div className="row">
                <p className="small-text">{item.departureAirportCode}</p>
                <h6 className="time-text">{item.departureTime}</h6>
                <p className="small-text text-grey">{item.departureDate}<br />{item.departureCity}</p>
              </div>
            </div>
            <div className="travel-time col-lg-4 col-md-4 col-4 text-center">
              <p className="small-text text-grey">{item.travelDuration}</p>
              <span><img src="assets/img/arrow.png" width={80}  /></span>
              {/* <p className="small-text text-grey">{item.stop }</p> */}
            </div>
            <div className="route-details-area col-lg-4 col-md-4 col-4">
              <div className="row">
                <p className="small-text">{item.arrivalAirportCode}</p>
                <h6 className="time-text">{item.arrivalTime}</h6>
                <p className="small-text text-grey">{item.arrivalDate}<br />{item.arrivalCity}</p>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 airline-price-area">
           <ul className="d-flex flex-row">
            <li className="mr-10"><strong>PNR: {item.airlinePnr}</strong></li>
            <li className="mr-10">{item.airlineFlightClass}</li>
            <li className="mr-10"> {item.cabinBaggage.length > 0 && (
                  <p className="small-text"><img src="assets/img/baggage.svg" width={15} /> {item.cabinBaggage}</p>
               )}</li>
           </ul>
          
              
            </div>
            
          </div>
        </div>
          ))}
        </div>
        </div>
)}

{/* flight details mobile ends */}



        {this.state.BookingResponse.status == true && this.state.BookingResponse.statusReturn == true && (
        <div className="travel-details">
        <h4>Traveller Details</h4>
       <div className="bg-white p-2 mb-3">
       <table className="table pax-table">
        <tbody>
        {this.state.BookingPaxlistRsp && this.state.BookingPaxlistRsp.map((item, index) => (
          item && // Check if item is not null or undefined
          <tr key={index}>
            <td align="left">
              <img src="assets/img/user.svg" width={25}/>{item.paxName}
            </td>
            <td align="right">{item.paxType}</td>
          </tr>
        ))}

          {/* <tr>
          <td align="left"><img src="assets/img/user.svg" width={50}/>Second Passenger Name</td>
           <td align="right">Child</td>
        </tr>
        <tr>
          <td align="left"><img src="assets/img/user.svg" width={50}/>Third Passenger Name</td>
           <td align="right">Infant</td>
        </tr> */}
        </tbody>
       </table>
       </div>
        </div>
        )}
      </div>
      <div className="col-lg-3 col-md-3">
       <div className="bg-white p-3">
        <h4 className="no-margin"><img src="assets/img/support.svg" width={30}/> {this.state.contactNo || "Loading..."}</h4>
        <h4 className="no-margin"><img src="assets/img/email.svg" width={30}/> {this.state.email || "Loading..."}</h4>
       </div>
     
       
      </div>
    </div>
  </div>
</div>



    </div>
   ) :  (
    <div>
        
    <div className="loader">
<div className="wait"> 
<h4>Hold on!</h4>
We are fetching the best fares for You!
</div>
{/* <div class="iata_code departure_city">CDG</div> */}
<div className="plane1">
<img src="assets/img/loader.gif" class="plane1-img" />
</div>
<div class="earth-wrapper">
<div class="earth"></div>
</div>  
{/* <div class="iata_code arrival_city">JFK</div> */}  
</div>

</div>
)
  }
}

// function WithNavigate(props) {
//   let location= useLocation();
//   return <BookingSuccess {...props} location={location}/>
// }

// export default WithNavigate;
const TranslatedHomePage = withTranslation()(BookingSuccess);
function WithNavigate(props) {
  let navigate = useNavigate();
  return <TranslatedHomePage {...props} navigate={navigate} />;
}

export default WithNavigate;